"use client";
import { usePricing } from "@/components/pricing/PricingProvider";
import Image from "next/image";
import Link from "next/link";
import { formatCurrency } from "@/utils/pricing";
import styles from "./SimilarVehicles.module.css";

interface VehicleCardProps {
    id: string;
    vin: string;
    name: string;
    price: number;
    mileage: string;
    image: string;
    trim?: string;
    className?: string;
}

export default function VehicleCard({ vin, name, price, mileage, image, trim, className = "" }: VehicleCardProps) {
    const { getNoHagglePricing } = usePricing();
    const pricing = getNoHagglePricing(price);
    const displayPrice = pricing ? formatCurrency(Math.round(pricing.noHagglePrice)) : "Contact for Price";
    const displayMileage = mileage && mileage !== "0" ? `${mileage} mi` : "Mileage unavailable";

    return (
        <article className={[styles["card"], className].filter(Boolean).join(" ")}>
            <Link
                href={`/cars/${vin}`}
                className={styles["cardLink"]}
                aria-label={`View ${name}`}>
                <div className={styles["imageWrap"]}>
                    <Image
                        fill
                        src={image}
                        alt={name}
                        className={styles["image"]}
                        sizes="(max-width: 620px) 82vw, (max-width: 900px) 50vw, 25vw"
                    />
                    {pricing && <span className={styles["feeBadge"]}>NO DEALER FEES</span>}
                </div>

                <div className={styles["cardBody"]}>
                    <h3 className={styles["vehicleName"]}>{name}</h3>
                    {trim && <p className={styles["trim"]}>{trim}</p>}
                    <div className={styles["cardMeta"]}>
                        <strong>{displayPrice}</strong>
                        <span>{displayMileage}</span>
                    </div>
                </div>
            </Link>
        </article>
    );
}
